import { Col, Dropdown, Row, Select, Space, Tabs, TabsProps } from 'antd';
import { Content } from 'antd/es/layout/layout';
import {
  AddIcon,
  ChatIcon,
  DownloadIcon,
  FilterGoldIcon,
  FilterIcon,
  Polygon,
  TrendingUpIcon,
  WhiteEditIcon,
} from 'assets/svg';
import { MainLayout } from 'components';
import Button from 'components/Button';
import useQueryParam from 'hooks/useQueryPrams';
import React, { useEffect, useRef, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { IPortfolio } from 'interface/portfolio.interface';
import AllocateCapitalRemain from 'components/Modules/Declare/AllocateCapitalRemain';
import PerBranch from 'components/Modules/Declare/PerBranch';
import PerShop from 'components/Modules/Declare/PerShop';
import InfoCart from 'components/Modules/Declare/InfoCart';
import { useUser } from 'contexts/User';
import { MenuProps } from 'antd/lib';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import PortfolioApi from 'apis/PortfolioApi';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';
import CartApi from 'apis/CartApi';
import { ICart } from 'interface/cart.interface';
import { openNotificationWithIcon } from 'utils/notification';
import { DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { headerFlowReg } from 'constants/exportFlowReg';

const DeclarePage = () => {
  const location = useLocation<{
    cart: any;
  }>();

  const cart = location.state.cart;

  const [cartDetail, setCartDetail] = useState<ICart>();

  const { Option } = Select;
  const { user } = useUser();
  const history = useHistory();
  const childRef = useRef<any>(null);
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [dataExport, setDataExport] = useState<any>();
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const { mutate: getDetail, isLoading: isCartLoading } = useMutation(
    ['getDetail'],
    () => CartApi.getDetail(cart.cart_id.toString()),
    {
      onSuccess: (response) => {
        if (response.status === STATUS.SUCCESS) {
          setCartDetail(response.data);
          setTitle(`${response.data.cart_code} - ${response.data.cart_name}`);
          setBreadcrumb([
            {
              title: (
                <p>
                  <a href="">Phê duyệt</a>
                </p>
              ),
            },
            {
              title: (
                <p>
                  <a href="/list-approve">Phê duyệt đặt hàng</a>
                </p>
              ),
            },
            { title: <a href="">{response.data.cart_name}</a> },
          ]);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const items: TabsProps['items'] =
    user?.role.includes('nguoi_dat_hang') ||
    user?.role.includes('cua_hang_truong')
      ? [
          {
            label: 'Đơn hàng',
            key: '1',
            children: <AllocateCapitalRemain ref={childRef} cart={cart} />,
          },
          {
            label: 'Thông tin giỏ hàng',
            key: '2',
            children: <InfoCart cart={cartDetail} />,
          },
        ]
      : user?.plantCode == 1000
      ? [
          {
            label: 'Đơn hàng',
            key: '1',
            children: <AllocateCapitalRemain ref={childRef} cart={cart} />,
          },
          {
            label: 'Phê duyệt chi nhánh',
            key: '2',
            children: <PerBranch cart={cart} />,
          },
          {
            label: 'Phê duyệt cửa hàng',
            key: '3',
            children: <PerShop cart={cart} />,
          },
          {
            label: 'Thông tin giỏ hàng',
            key: '4',
            children: <InfoCart cart={cartDetail} />,
          },
        ]
      : user?.role.includes('asm')
      ? [
          {
            label: 'Phê duyệt cửa hàng',
            key: '1',
            children: <PerShop cart={cart} />,
          },
          {
            label: 'Thông tin giỏ hàng',
            key: '2',
            children: <InfoCart cart={cartDetail} />,
          },
        ]
      : [
          {
            label: 'Phê duyệt cửa hàng',
            key: '1',
            children: <PerShop cart={cart} />,
          },
          {
            label: 'Đơn hàng',
            key: '2',
            children: <AllocateCapitalRemain ref={childRef} cart={cart} />,
          },
          {
            label: 'Thông tin giỏ hàng',
            key: '3',
            children: <InfoCart cart={cartDetail} />,
          },
        ];

  const ApproveRequestButton: MenuProps = {
    items: [
      {
        label: 'Báo cáo 1',
        key: '1',
      },
      {
        label: 'Báo cáo 2',
        key: '2',
      },
      {
        label: 'Báo cáo 3',
        key: '3',
      },
    ],
  };

  useEffect(() => {
    getDetail();
  }, [page, page_size]);

  const onGoToAddTracking = () => {
    console.log('go to add');
  };

  const onGoToReport = () => {
    console.log('go to report');
  };

  function openChat() {
    console.log('Function not implemented.');
  }

  const checkRole = (user: any) => {
    switch (user?.role[0]) {
      case 'nguoi_dat_hang':
        return history.push(`/order/tvv-view/${cart.cart_register_id}`);
      case 'super_admin':
      case 'admin':
      case 'cua_hang_truong':
        return history.push(`/order/cht-view/${cart.cart_register_id}`);
      default:
        return history.push(`/detail-approve-order-list`, {
          cart: cart,
          isViewDetailAllBranch: true,
        });
    }
  };

  const checkBeforeSendApprove = async () => {
    if (childRef && childRef.current) {
      childRef.current.checkBeforeSendApprove();
    }
  };

  function generateExcel(dataExport: any) {
    const data = [];

    // create title
    const header = headerFlowReg.map((column) => {
      return column.title;
    });

    data.push(header);

    // create data
    dataExport.forEach((prm) => {
      const rowData = headerFlowReg.map((column) => {
        if (
          column.dataIndex == 'date_started' ||
          column.dataIndex == 'date_end' ||
          column.dataIndex == 'create_at' ||
          column.dataIndex == 'request_date'
        ) {
          const data = prm[column.dataIndex]
            ? prm[column.dataIndex].slice(0, 10)
            : '';
          return data;
        } else if (column.dataIndex == 'status') {
          return convertStatus(prm[column.dataIndex]);
        } else return prm[column.dataIndex]?.toString();
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `Theo dõi đăng ký.xlsx`);
  }

  const { mutate: exportTheoDoiDangKy, isLoading: isExportLoading } =
    useMutation(CartApi.exportTheoDoiDangKy, {
      onSuccess: (data: any) => {
        if (data.status === 'success') {
          generateExcel(data?.data);
        } else {
          openNotificationWithIcon('success', 'Export thành công');
        }
      },
      onError: (error) => {
        console.log('er: ', error);
        openNotificationWithIcon('error', 'Export thất bại');
      },
    });

  const handleExport = async () => {
    exportTheoDoiDangKy({ cart_register_id: cart.cart_register_id });
  };

  const convertStatus = (status: number) => {
    switch (status) {
      case undefined:
      case null:
      case 0:
        return 'Mới tạo';
      case 1:
        return 'CHT duyệt và gửi CN';
      case 2:
        return 'CN duyệt';
      case 3:
        return 'CN từ Chối';
      case 4:
        return 'HS duyệt';
      case 5:
        return 'HS từ chối';
      default:
        return '-';
    }
  };

  return (
    <MainLayout isLoading={isCartLoading || isExportLoading}>
      <p className="text-primary-50 font-medium">Hàng khuyến nghị</p>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-4"
      >
        <Col span={16} className="flex justify-end">
          <Button
            bgColor={'bg-white'}
            color={'text-primary-50'}
            border={'border-primary-50'}
            customClass="fix-border-radius mr-2"
            onClick={handleExport}
          >
            <DownloadOutlined />
            Tải file status
          </Button>
          {user?.plantCode == 1000 ? (
            <Space>
              <Button
                noneBold={true}
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
                onClick={onGoToReport}
              >
                <TrendingUpIcon />
                Báo cáo
              </Button>
              <Button
                noneBold={true}
                bgColor={'bg-primary-50'}
                color={'text-white'}
                border={'border-primary-50'}
                onClick={onGoToAddTracking}
              >
                <AddIcon />
                Tạo tracking number
              </Button>
            </Space>
          ) : (
            <Space>
              {/* <Button
                noneBold={true}
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
                onClick={openChat}
              >
                <ChatIcon />
              </Button>
              <Button
                noneBold={true}
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
                onClick={onGoToReport}
              >
                <TrendingUpIcon />
                Báo cáo
              </Button> */}
              <Button
                noneBold={true}
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
                onClick={() => checkRole(user)}
              >
                Chi tiết phê duyệt
              </Button>
              {/* <Button
                noneBold={true}
                color={'text-white'}
                border={'border-white'}
                onClick={checkBeforeSendApprove}
                disabled={cart?.status == 0 ? false : true}
                bgColor={cart?.status == 0 ? 'bg-primary-50' : 'bg-gray-300'}
              >
                <WhiteEditIcon />
                Yêu cầu phê duyệt
              </Button> */}
            </Space>
          )}
        </Col>
      </Row>
      <Content className="relative p-0 m-0">
        <Tabs
          items={items}
          defaultActiveKey="1"
          className="-my-5"
          // tabBarExtraContent={
          //   <span
          //     className="border border-solid boder-primary-50 rounded-lg font-sans text-sm py-1 px-2 leading-5 bg-gray-100 uppercase"
          //     style={{ color: '#4da6ff' }}
          //   >
          //     {cart?.status == 0
          //       ? 'Mới tạo'
          //       : cart?.status == 1
          //       ? 'Chờ duyệt'
          //       : cart?.status == 2
          //       ? 'Đã duyệt'
          //       : cart?.status == 3
          //       ? 'Từ chối'
          //       : cart?.status == 4
          //       ? '-'
          //       : undefined}
          //   </span>
          // }
          onChange={() => {
            history.push('/declare', { cart: cart });
          }}
        />
      </Content>
    </MainLayout>
  );
};

export default DeclarePage;
